import { AbstractControl, ValidationErrors } from '@angular/forms';
import * as lpn from 'google-libphonenumber';

export const phoneNumberValidator = (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }

  const isRequired = control.errors && control.errors?.required === true;

  const error = { validatePhoneNumber: { valid: false } };

  if (isRequired) {
    return error;
  }

  let phone: lpn.PhoneNumber;

  try {
    phone = lpn.PhoneNumberUtil.getInstance().parse(control.value.number, control.value.countryCode);
  } catch (e) {
    return error;
  }

  if (control.value) {
    if (!phone) {
      return error;
    } else {
      if (!lpn.PhoneNumberUtil.getInstance().isValidNumberForRegion(phone, control.value.countryCode)) {
        return error;
      } else {
        return null;
      }
    }
  }
};
